// extracted by mini-css-extract-plugin
export var copyIcon = "_xu-2";
export var discountCard = "_xu-0";
export var discountCode = "_xu-3";
export var discountContent = "_xu-1";
export var loadingCard = "_xu-4";